import { render, staticRenderFns } from "./ProductStorage.vue?vue&type=template&id=35e85232&scoped=true&lang=pug&"
import script from "./ProductStorage.vue?vue&type=script&lang=ts&"
export * from "./ProductStorage.vue?vue&type=script&lang=ts&"
import style0 from "./ProductStorage.vue?vue&type=style&index=0&id=35e85232&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e85232",
  null
  
)

export default component.exports